<template>
  <div>
    <div class="card p-4">
      <div class="card-header w-100">
        <div class="row">
          <div class="col-md-4">
            <div class="card-title">Вакансии</div>
          </div>
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <input type="text"
                     class="form-control"
                     placeholder="Поиск..."
                     v-model="params.q"
                     @input="search($event)"
              />

              <button class="btn btn-primary d-flex align-items-center ml-3 px-3 py-2"
                      @click="navigateTo()">
                <i class="fas fa-plus"></i>
                <span class="ml-2">Добавить</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body mt-3">
        <div class="d-flex flex-wrap">
          <div class="custom-control custom-radio mr-3 mb-3"
               v-for="(option, index) in options"
               :key="index">
            <input class="custom-control-input"
                   type="radio"
                   :id="`radio${index + 1}`"
                   :value="option.value"
                   v-model="params.is_archive"
                   :checked="option.value === params.is_archive"
                   @change="pageInitialize"
            />
            <label class="custom-control-label cursor-pointer"
                   :for="`radio${index + 1}`">{{ option.title }}</label>
          </div>
        </div>
        <div v-if="team.length && !isLoading"
             class="table-responsive mt-4">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Номер</th>
                <th>ФИО</th>
                <th>Должность</th>
                <th>Статус</th>
                <th></th>
              </tr>
            </thead>
            <tbody class="w-100">
              <tr v-for="(teamItem, teamIndex) in team"
                  :key="`team-mate-${teamIndex}`">
                <td>{{ teamItem.id }}</td>
                <td>{{ teamItem.full_name }}</td>
                <td>{{ teamItem.post }}</td>
                <td>{{ teamItem.is_archive ? 'Да' : 'Нет' }}</td>
                <td class="d-flex align-items-center justify-content-end">
                  <button class="btn btn-primary"
                          @click="navigateTo(teamItem.slug)">
                    <i class="fas fa-eye"></i>
                  </button>
                  <button
                    class="btn btn-danger ml-2"
                    @click="openDestroyingModal(String(teamItem.slug))"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <paginate v-if="teamPages > 0"
                    class="mt-5"
                    :page-count="teamPages"
                    :page-range="10"
                    v-model="params.page"
                    :margin-pages="2"
                    :click-handler="nextPage"
                    :prev-text="''"
                    :next-text="''"
                    :container-class="'pagination'"
                    :page-class="'page-item'" />
        </div>
        <div class="d-flex justify-content-center py-7" v-else-if="!isLoading">
          <p>Нет объявлений!</p>
        </div>
      </div>
    </div>
    <sweet-modal ref="destroyingModal" >
      <DestroyingModal
        v-if="destroyingId"
        :slug="destroyingId"
        @confirm="confirmDestroying"
        @cancel="closeDestroyingModal"
      />
    </sweet-modal>
  </div>
</template>

<style lang="scss">
.sweet-action-close {
  z-index: 999 !important;
}
.sweet-action-close:hover {
  background-color: #25d7cd !important;
}
.sweet-content {
  padding: 24px 32px !important;
}
.sweet-modal {
  background: #fff !important;
}
.sweet-modal-overlay {
  background: rgba(#fff, 0.9) !important;
}
</style>

<script>
import { debounce } from "debounce";
import { SweetModal } from "sweet-modal-vue";
import { mapState, mapActions } from "vuex";

import DestroyingModal from "@/components/modals/DestroyingModal";
import { DELETE_TEAMMATE, FETCH_TEAM } from "@/store/types/actions.type";
import loaderMixin from "@/mixins/loader.mixin";

export default {
  name: "List",
  components: {
    SweetModal,
    DestroyingModal,
  },
  mixins: [
      loaderMixin,
  ],
  data() {
    return {
      options: [
        {
          title: "Активный",
          value: 0,
        },
        {
          title: "В архиве",
          value: 1,
        },
      ],
      params: {
        is_archive: 0,
        page: 1,
      },
      destroyingId: null,
    };
  },
  computed: {
    ...mapState('team', {
      team: state => state.team,
      teamPages: state => state.teamPages
    }),
  },
  async created() {
    await this.pageInitialize();
  },
  methods: {
    ...mapActions({
      fetchTeamRequest: `team/${FETCH_TEAM}`,
      removeTeammateRequest: `team/${DELETE_TEAMMATE}`
    }),
    async pageInitialize() {
      try {
        this.showLoader();
        await this.fetchTeamRequest(this.params);
      } catch(e) {
        console.log(e, '[ ERROR ] | PageInitialize')
        throw e;
      } finally {
        this.hideLoader();
      }
    },
    navigateTo(slug=null) {
      const routerParameters =
          slug ? {name: "team-edit", params: {slug}} : {name: "team-add"}

      this.$router.replace(routerParameters)
    },
    nextPage(page) {
      this.params.page = page;
      this.pageInitialize();
    },
    openDestroyingModal(slug) {
      this.destroyingId = slug;
      this.$refs.destroyingModal.open();
    },
    closeDestroyingModal() {
      this.destroyingId = null;
      this.$refs.destroyingModal.close();
    },
    async confirmDestroying(id) {
      try {
        await this.removeTeammateRequest(id);
        this.destroyingId = null;
        this.$toasted.show("Удалено!");
      } catch(e) {
        this.$toasted.show("Произошла ошибка! Повторите операцию позже");
      } finally {
        this.closeDestroyingModal();
        await this.pageInitialize();
      }
    },
    search: debounce(function(event) {
      this.params.page = 1;
      if (event.target.value) {
        this.params.q = event.target.value;
      } else {
        delete this.params.q;
      }
      this.pageInitialize();
    }, 1000),
  },
  beforeDestroy() {
    this.hideLoader();
  },
};
</script>
